import React from "react";
import { Box, Typography } from "@material-ui/core";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import { useStyles } from "./yourInvestment.style";

const YourInvestment = (props) => {
  const classes = useStyles();
  const { transaction = {}, project = {} } = props;

  return (
    <Box className={classes.summaryCard}>
      <Typography className={classes.summaryTitle}>YOUR PURCHASE</Typography>

      <Box className={classes.productRow}>
        <img
          className={classes.productImage}
          src={project.image}
          alt={project.title_project}
        />
        <Box>
          <Typography className={classes.productLabel}>
            {transaction.type === "buy_bonds"
              ? "FORWARD"
              : transaction.type === "buy_sbt"
              ? "CARBON CREDIT"
              : "CARBON CREDIT"}
          </Typography>
          <Typography className={classes.productName}>
            {project.title_project}
          </Typography>
          <Typography className={classes.productRegion}>
            {project.region}, {project.country}
          </Typography>
        </Box>
      </Box>

      <Box className={classes.divider} />

      <Box className={classes.paymentSection}>
        <Box className={classes.calcRow}>
          <Typography className={classes.calcLabel}>Subtotal</Typography>
          <Typography className={classes.calcValue}>
            ${parseFloat(transaction.subtotal || 0).toFixed(2)}
          </Typography>
        </Box>

        <Box className={classes.calcRow}>
          <Typography className={classes.calcLabel}>Protocol Fee</Typography>
          <Typography className={classes.calcValue}>
            ${parseFloat(transaction.feeValue || 0).toFixed(2)}
          </Typography>
        </Box>

        <Box className={classes.totalRow}>
          <Typography className={classes.totalLabel}>Total</Typography>
          <Typography className={classes.totalValue}>
            ${parseFloat(transaction.total || 0).toFixed(2)}
          </Typography>
        </Box>
      </Box>

      <Box className={classes.impactAlert}>
        <VerifiedUserIcon className={classes.impactIcon} />
        <Typography className={classes.impactText}>
          Your transaction will offset{" "}
          <span className={classes.impactBold}>
            {transaction.co2_emission || "0"} tonnes
          </span>{" "}
          of CO2 equivalent emissions.
        </Typography>
      </Box>
    </Box>
  );
};

export default YourInvestment;
